import useManyRemoteM1 from '@aims/shared/shared/use-many-remote-m1';
import { gql } from '@apollo/client';
import { useRef, useState } from 'react';
import settings from '../../../settings';

export const query = gql`
  query AllTrainingCoursesForUser(
    $first: Int
    $after: String
    $filters: TrainingCourseFiltersForUser
    $sortBy: [SortBy]
  ) {
    allTrainingCoursesForUser(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          _id
          courseName
          desc
          primaryThumbnailUrl
          modules {
            _id
            name
            desc
          }
          numFiles
          createdAt
          updatedAt
          deletedAt
        }
      }
    }
  }
`;

const extract = (data) => data?.allTrainingCoursesForUser;

function useTrainingCourses(filters, queryId) {
  const [sortedBy, setSortedBy] = useState('courseName.keyword');
  const [sortOrder, setSortOrder] = useState('DESC');

  const sortBy = useRef([
    { key: sortedBy, order: sortOrder },
    { key: '_score', order: 'DESC' },
  ]);

  const { error, loading, data, search, hasNextPage, next, refetch, reset } =
    useManyRemoteM1({
      query,
      extract,
      first: settings.querySize,
      filters,
      sortBy: sortBy.current,
      fetchPolicy: 'cache-first',
      queryId,
    });
  return {
    error,
    loading,
    data,
    search,
    hasNextPage,
    next,
    refetch,
    reset,
  };
}

export default useTrainingCourses;
